import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/** Compact icon-only toggle for the header. */
export default function ThemeToggle() {
  const { theme, toggle } = useTheme() || { theme: "light", toggle: () => {} };
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label="Toggle color theme"
      data-testid="theme-toggle-btn"
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-full
                 border border-forest/20 bg-white/70 dark:bg-forest/40 dark:border-sage/30
                 hover:bg-forest/5 dark:hover:bg-forest/60 transition-colors"
    >
      <Sun className={`w-4 h-4 text-forest transition-all ${isDark ? "opacity-0 -rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`} />
      <Moon className={`w-4 h-4 text-honey absolute transition-all ${isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-50"}`} />
    </button>
  );
}
